import {useNavigate, useParams} from "react-router-dom";
import React, {useContext, useState} from "react";
import Password from "../../../../../components/Password/Password";
import "./assets/passwordModal.scss"
import CheckPassModalState from "./interfaces/CheckPassModalState";
import CheckPassModalController from "./controller/CheckPassModalController";
import {MarketContext} from "../../../../Main/context/MarketContext";
import moment from "moment-jalaali";
import "moment/locale/ar";
import {useTranslation} from "react-i18next";

export default function CheckPassModal() {
    const {t, i18n} = useTranslation()
    const {shopId} = useParams();
    const navigate = useNavigate();
    const context = useContext(MarketContext)
    const [state, setState] = useState<CheckPassModalState>({
        value: "",
    })

    if (!shopId) return null;

    return (
        <div className={"check-pass-modal"}>
            <span>{i18n.language === 'ar-IQ' ? moment().locale('ar').format('dddd D MMMM YYYY - HH:mm') : moment().locale('fa').format('dddd jD jMMMM jYYYY - HH:mm')}</span>
            <form
                onSubmit={e => new CheckPassModalController(state, setState).submitPassword(e, context, navigate, shopId)}>
                <div className={'parent-password'}>
                    <Password keyState={"value"}
                              setState={setState}
                              label={t("setting.password")}
                              placeholder={t("setting.password")}/>
                    {state.error ? <small>{state.message}</small> : null}
                </div>
                <button type={'button'} onClick={() => window.dispatchEvent(new Event('closeModal'))}>{t("cancel")}</button>
                <button type={'submit'} className={"submit-btn"}>{t("confirm")}</button>
            </form>
        </div>
    )
}